import { useNavigate } from "react-router-dom"
import { Fleets } from "../components/Fleets"
import { Header } from "../components/Header"
import { Services } from "../components/Services"
import { WhatSetUsApart } from "../components/WhatSetUsApart"
import { Helmet } from "react-helmet-async"

export const Home = () => {
    const navigate = useNavigate();

    return (
        <div>
            <Helmet>
                <title>Velox Charter | Charter Transportation, Airport Transfers & Group Travel</title>

                <meta
                    name="description"
                    content="Velox Charter provides safe, reliable, and professional charter transportation services across the USA. Book airport transfers, corporate transportation, group travel, employee shuttles, event transportation, and private charter services with our modern fleet."
                />
            </Helmet>
            
            <Header />
            <Services />
            <Fleets />
            <WhatSetUsApart />
            <section className="bg-primary py-12 md:py-16">

                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">

                        {/* Left Content */}
                        <div className="max-w-4xl">
                            <h2 className="text-white text-4xl md:text-5xl font-semibold leading-tight">
                                Get Your Free Quote
                            </h2>

                            <p className="mt-6 max-w-3xl mx-auto text-white text-base md:text-lg leading-relaxed">
                                Tell us about your transportation needs, and our team will provide a customized quote tailored to your
                                itinerary, group size, and travel requirements.
                            </p>
                        </div>

                        {/* Right Button */}
                        <div className="flex lg:justify-end">
                            <button
                                className="
                                bg-secondryBlue
                                hover:bg-[#1697d8]
                                text-white
                                px-5 py-[10px]
                                text-lg font-medium rounded-[25px] hover:shadow-md hover:opacity-90
                            "
                                onClick={() => navigate("/get-quote")}
                            >
                                Get Your Quote
                            </button>
                        </div>

                    </div>
                </div>
            </section>
        </div>
    )
}